import { tokens } from "@blurb/codex-react";
import { Box } from "@mantine/core";
import React from "react";
import { Body } from "../../../components/Typography";
import { RpiTableColumn } from "../RpiTable";
import { RpiTableHead } from "../RpiTableHead";
import { getColumnsTotalSize } from "../RpiTableHelpers";
import { useRpiTableStyles } from "../RpiTableStyles";

export interface RpiTableEmptyStateProps {
  message?: string;
  columns: RpiTableColumn<any>[];
}
export const RpiTableEmptyState: React.FC<RpiTableEmptyStateProps> = ({ message, columns }) => {
  const { classes } = useRpiTableStyles();
  const totalSize = getColumnsTotalSize(columns);

  return (
    <table className={classes.table}>
      <RpiTableHead columns={columns} totalSize={totalSize} />
      <tbody>
        <tr>
          <td colSpan={columns.length}>
            <EmptyMessage message={message} />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

interface EmptyMessageProps {
  message?: string;
}

const EmptyMessage: React.FC<EmptyMessageProps> = ({ message = "No data found." }) => {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: tokens.spacing[4],
        backgroundColor: tokens.color.semantic.bg.surface,
        paddingBlock: tokens.spacing[6],
        paddingInline: tokens.spacing[4],
        color: tokens.color.semantic.text.subtle,
      }}
    >
      <Body>{message}</Body>
    </Box>
  );
};
